import { SingleSelectField } from "@dgs/core";
import { FC, useMemo } from "react";
import { DataFieldType } from "../../../shared/types/dataField";

interface Props {
	name: string;
	label: string;
	currentDataFieldType?: DataFieldType;
}

const allOptions = Object.values(DataFieldType);
const getValue = (type: DataFieldType) => type;
const getLabel = (type: DataFieldType) => type;
export const DataFieldTypeSelect: FC<Props> = ({ label, name, currentDataFieldType }) => {
	const options = useMemo(() => {
		if (!currentDataFieldType) return allOptions;

		switch (currentDataFieldType) {
			case DataFieldType.CHECKBOX_GROUP:
			case DataFieldType.MULTI_SELECT_FIELD:
				return [DataFieldType.CHECKBOX_GROUP, DataFieldType.MULTI_SELECT_FIELD];
			case DataFieldType.TEXT:
			case DataFieldType.LONG_TEXT:
				return [DataFieldType.TEXT, DataFieldType.LONG_TEXT];
		}

		return [];
	}, [currentDataFieldType]);

	return (
		<SingleSelectField
			label={label}
			name={name}
			options={!options.length ? allOptions : options}
			getLabel={getLabel}
			getValue={getValue}
			disabled={!options.length}
		/>
	);
};
